//// CONTACT FORM ////
// https://codyhouse.co/gem/css-contact-form/

if ($('.floating-labels').length > 0) floatLabels();

function floatLabels() {
    var inputFields = $('.floating-labels .cd-label').next();
    inputFields.each(function() {
        var singleInput = $(this);
        //check if user is filling one of the form fields
        // checkVal(singleInput);
        singleInput.on('change keyup', function() {
            checkVal(singleInput);
        });

        singleInput.on("focusin", function() {
            $(this).prev('.cd-label').addClass('float2');
        });

        singleInput.on("focusout", function() {
            $(this).prev('.cd-label').removeClass('float2');
        });
    });
}

function checkVal(inputField) {
    (inputField.val() == '') ? inputField.prev('.cd-label').removeClass('float'): inputField.prev('.cd-label').addClass('float');
}


//FIX move label if input is filled
var inputFilled = document.querySelectorAll("input[type='text'], input[type='email'], input[type='tel'], input[type='number'], input[type='password'], select, textarea");
for (var i = 0; i < inputFilled.length; i++) {
    if (inputFilled[i].value.length > 0) {
        inputFilled[i].previousElementSibling.classList.add('float');
    }
}